module.exports = __webpack_public_path__ + "img/right-arrow-grey.ed6118c2.svg";